export default {
    errorBanner: {
        dismiss: 'Odbaci',
    },
}
